/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCustomList,
    InternalApiCustomListFromJSON,
    InternalApiCustomListToJSON,
} from '../models';

export interface AddListRequest {
    internalApiCustomList: InternalApiCustomList;
}

export interface ArchiveListRequest {
    customListId: string;
}

export interface GetListByIdRequest {
    customListId: string;
}

export interface UpdateListRequest {
    customListId: string;
    internalApiCustomList: InternalApiCustomList;
}

/**
 * 
 */
export class CustomListApi extends runtime.BaseAPI {

    /**
     * Creates new custom list
     */
    async addListRaw(requestParameters: AddListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomList>> {
        if (requestParameters.internalApiCustomList === null || requestParameters.internalApiCustomList === undefined) {
            throw new runtime.RequiredError('internalApiCustomList','Required parameter requestParameters.internalApiCustomList was null or undefined when calling addList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListToJSON(requestParameters.internalApiCustomList),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListFromJSON(jsonValue));
    }

    /**
     * Creates new custom list
     */
    async addList(requestParameters: AddListRequest, initOverrides?: RequestInit): Promise<InternalApiCustomList> {
        const response = await this.addListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Archive custom list (soft delete)
     */
    async archiveListRaw(requestParameters: ArchiveListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling archiveList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Archive custom list (soft delete)
     */
    async archiveList(requestParameters: ArchiveListRequest, initOverrides?: RequestInit): Promise<void> {
        await this.archiveListRaw(requestParameters, initOverrides);
    }

    /**
     * Get custom list by id
     */
    async getListByIdRaw(requestParameters: GetListByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomList>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getListById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListFromJSON(jsonValue));
    }

    /**
     * Get custom list by id
     */
    async getListById(requestParameters: GetListByIdRequest, initOverrides?: RequestInit): Promise<InternalApiCustomList> {
        const response = await this.getListByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get custom lists
     */
    async getListsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCustomList>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCustomListFromJSON));
    }

    /**
     * Get custom lists
     */
    async getLists(initOverrides?: RequestInit): Promise<Array<InternalApiCustomList>> {
        const response = await this.getListsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update custom list
     */
    async updateListRaw(requestParameters: UpdateListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomList>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling updateList.');
        }

        if (requestParameters.internalApiCustomList === null || requestParameters.internalApiCustomList === undefined) {
            throw new runtime.RequiredError('internalApiCustomList','Required parameter requestParameters.internalApiCustomList was null or undefined when calling updateList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListToJSON(requestParameters.internalApiCustomList),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListFromJSON(jsonValue));
    }

    /**
     * Update custom list
     */
    async updateList(requestParameters: UpdateListRequest, initOverrides?: RequestInit): Promise<InternalApiCustomList> {
        const response = await this.updateListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
